import {pxToRem} from '../../../../utills/pxToRem'
import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'

const {md} = sizes.container
export const contentStyle = {
    h2: {
        fontSize: pxToRem(16),
        margin: `${pxToRem(16)} 0`,
        paddingTop: pxToRem(10),
        letterSpacing: pxToRem(1),
        color: 'cav_light_black',

        [`@media (max-width: ${md})`]: {
            fontSize: pxToRem(28),
            margin: `${pxToRem(24)} 0`
        }
    },

    h3: {
        fontSize: pxToRem(14),
        margin: `${pxToRem(14)} 0`,
        color: 'cav_light_black'
    },

    p: {
        fontSize: pxToRem(12),
        lineHeight: pxToRem(24),
        margin: `${pxToRem(12)} 0`,
        color: 'cav_light_black',

        a: {
            color: 'cav_light_black'
        },

        [`@media (max-width: ${md})`]: {
            fontSize: pxToRem(12),
            letterSpacing: pxToRem(1.28)
        }
    },

    'center:has(> img)': {
        display: 'flex',
        justifyContent: 'center',
        gap: `${pxToRem(10)} ${pxToRem(3)}`,
        [`@media (max-width: ${md})`]: {
            flexDirection: 'column',
            width: '70%',
            margin: 'auto'
        }
    },

    ul: {
        marginBlock: pxToRem(16),
        paddingInline: pxToRem(24),

        li: {
            fontWeight: 400,
            letterSpacing: pxToRem(1.12),
            lineHeight: pxToRem(24),
            fontSize: pxToRem(12),
            color: 'cav_light_black',
            fontFamily: fonts.primary,

            [`@media (max-width: ${md})`]: {
                letterSpacing: pxToRem(1.28)
            }
        }
    },

    hr: {
        marginTop: pxToRem(15)
    },

    '.anchor-target': {
        scrollMarginTop: '140px'
    }
}
